(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','$rootScopeProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('orderStatistics', {
                parent: 'module',
                url: '/orderStatistics',
                data: {
                    authorities: ['ROLE_STOCK_TAKING_ORDER']
                },
                views: {
                    'content': {
                        templateUrl: 'app/dataChart/orderStatistics.html',
                        controller: 'OrderStatisticsController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate) {
                        return $translate.refresh();
                    }]
                }
            })
    }
})();
